const 
  VR_FIELD_REQUIRED = 'required',
  VR_VALIDATE_PHONE = 'phone',
  VR_VALIDATE_EMAIL = 'email',  
  VR_MAX_LENGTH = 'maxlen';

class FormValidator {

  checkField(field) {
    // console.log(field);

    if (field.rule == VR_FIELD_REQUIRED) {
      return (!this.isEmpty(field))
    }

    if (field.rule == VR_MAX_LENGTH) {
      return (this.hasValidMaxLength(field))
    }
    
    if (field.rule == VR_VALIDATE_PHONE) {
      return this.isValidPhoneNumber(field);
    }

    if (field.rule == VR_VALIDATE_EMAIL) {
      return this.isValidEmail(field);
    }

    console.log(`Unknown validation rule for field #${field.id}`);
    return false;
  }


  /*

    маска для номера телефона +7 (___) ___-__-__

  */
  isValidPhoneNumber(field) {
    return /\+[78] \(\d{3}\) \d{3}-\d{2}-\d{2}/.test(field.node.value);
  }

  isValidEmail(field) {
    return /\b[\w\.-]+@[\w\.-]+\.\w{2,4}\b/gi.test(field.node.value);
  }

  isEmpty(field) {
    if (field.type == "phone") {
      return (field.node.value.trim().localeCompare('+7 (___) ___-__-__') == 0);
    }
    if (field.type == "email") {
    }
    return (field.node.value.trim() == "")
  }

  hasValidMaxLength(field) {
    return (field.node.value.trim().length <= field.maxlen)
  }

  hasValidMinLength(field) {
    return (field.node.value.trim().length >= field.minlen)
  }

}

const formValidator = new FormValidator();
formValidator.VR_FIELD_REQUIRED = VR_FIELD_REQUIRED,
formValidator.VR_VALIDATE_PHONE = VR_VALIDATE_PHONE;
formValidator.VR_VALIDATE_EMAIL = VR_VALIDATE_EMAIL;
formValidator.VR_MAX_LENGTH = VR_MAX_LENGTH;

export default formValidator;